// Navigation des Moduls `framework` (eager geladen; Quelle UX §2.2–§2.10). Besitzer: Modul framework.
import { Compass } from '@phosphor-icons/react';
import { defineMeta } from '@web/registry/define';

export default defineMeta({
  key: 'framework',
  title: 'Talent framework',
  nav: {
    people: [
      {
        key: 'framework.tab',
        label: 'Framework',
        icon: Compass,
        path: '/framework',
        roles: ['ALL'],
        order: 40,
        area: 'tabs:performance',
      },
    ],
    admin: [
      {
        key: 'framework.admin',
        label: 'Talent framework',
        icon: Compass,
        path: '/performance/framework',
        roles: ['ADM', 'PERF', 'CEO'],
        order: 230,
        area: 'Performance',
      },
    ],
  },
});
